export default __webpack_public_path__ + "static/media/no.9875f77b.jpg";